<template>
	<div id="">
		<div class="top_banner_box">
			<!-- current_fixed -->
			<img  :src="ossImgPath+'Ranking_bg.png'" v-show='checkoTabVal==2'  class="top_banner_img" alt="" />
			<img  :src="ossImgPath+'ranking_new.png'" v-show='checkoTabVal==1'   class="top_banner_img" alt="" />
			<img  :src="ossImgPath+'home_new/youpin_bangdan.png'" v-show="checkoTabVal=='excellent'"  class="top_banner_img" alt="" />
			<div class="fixed_box_top " :class="isFixed ? 'current_fixed':'' " >
				<ul class="flex_a ">
					<li  :class="checkoTabVal=='excellent'? 'active':'' "  @click="changeTab('excellent')">优品榜<i></i></li>
					<li  :class="checkoTabVal==2? 'active':'' " @click="changeTab(2)" >热门榜<i></i></li>
					<li  :class="checkoTabVal==1? 'active':'' "  @click="changeTab(1)">新品榜<i></i></li>
				</ul>
				<div class="radius_rectangle"></div>
			</div>
		</div>
		<div class="list_box index_z" v-if="list.length>0">
			<div class="list_box_warp">
			<!-- 	<van-list
				  v-model="loading"
				  :finished="finished"
				  finished-text="没有更多了"
				  @load="onLoad"
				  offset='100'
				> -->
					<div  v-for="(item,idx) in list" :key='idx'  @click="goPathUrl('/shopDetail?id=' + item.stock_id)" >
						<NewsProduct :index_s='idx' :itemCont = 'item' :is_show_retail_price="is_show_retail_price" ></NewsProduct>
					</div>
				<!-- </van-list> -->
			</div>
		</div>
		<div class="null_data_style" v-if="list.length==0">
			<img :src="ossImgPath+'null_new_x.png'" alt="" />
			<p>暂无商品</p>
		</div>
		<div class="zw" style="height: 2rem;"></div>
		<footerView></footerView>
	</div>
</template>

<script>
	import NewsProduct from '@/components/newsProduct'
	import footerView from "@/components/footerView.vue";
	import wx from 'weixin-js-sdk'
	import {
		sendRequest
	} from '../../assets/public'
	export default{
		components: {
			NewsProduct,
			footerView
		},
		data(){
			return{
				list: [],
				loading: false,
				finished: false,
				isFixed:false,
				page:1,
				checkoTabVal:'excellent',
				loading22: true,
				is_show_retail_price:0
			}
		},
		created(){
			wx.hideOptionMenu()
		},
		beforeRouteLeave(to, from, next) {
			console.log(to, from, next)
			if(to.path=='/shopDetail'){
				from.meta.keepAlive = true;
				console.log('去详情')
			}else{
				let vnode = this.$vnode
				let parentVnode = vnode && vnode.parent;
				if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
					var key = vnode.key == null
						    ? vnode.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
						    : vnode.key;
							
						    var cache = parentVnode.componentInstance.cache;
						    var keys = parentVnode.componentInstance.keys;
							    if (cache[key]) {
							    this.$destroy()
							    // remove key
								    if (keys.length) {
								    var index = keys.indexOf(key)
									    if (index > -1) {
									    	keys.splice(index, 1)
									    }
								    }
							    cache[key] = null
							    }	
						    }  
				}
			next();
		},
		mounted(){
			console.log('挂载啦吗')
			this.checkoTabVal = this.$route.query.type || 'excellent'
			this.getList()
			window.addEventListener('scroll', this.handleScroll)
		},
		methods:{
			goPathUrl(e){
				 this.$router.push({
				          path: e,
				        });
			},
			changeTab(val){
				console.log('jjj')
				this.checkoTabVal= val;
				this.loading=true
				 this.page=1
				 this.list=[]
				this.getList()
				// this.$router.replace({path:'/Ranking',query: {type:val}})
			},
			getList(){
				let _this= this;
				var apiname=_this.checkoTabVal=='excellent'?'goods/superior_list':'goods/rank_list'
				sendRequest(apiname, {
				  limit:50,
				  page: this.page,
				  tag_type:_this.checkoTabVal==2?'1':0, 
				  goods_type:'0',
				  order_type:_this.checkoTabVal==2? '':'desc',
				  order:_this.checkoTabVal==2? '':'add_time',
				})
				  .then((result) => {
					  _this.loading=false
					  _this.is_show_retail_price = result.content.is_show_retail_price
					  let resList= result.content.list
					  _this.list=this.page ==1 ? resList : [..._this.list,...resList]
					
				  })
				  .catch((err) => {});
			},
			onLoad(){
				console.log(this.page,'====')
				if(this.page==5  ||  this.page==1 )return false
				this.page++;
				this.getList()
			},
			handleScroll() {
			    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				const testEle = 166
			    if (scrollTop > testEle) {
			      this.isFixed = true
				  
			    } else {
			      this.isFixed = false
			
			    }
			  }
		}
	}
</script>

<style scoped>
	page{
		background: #FF2612;
	}
	.list_box{
		background: #F7F8FA;
		font-size: 0.48rem;
		padding: 0.2rem 0.4rem 1rem;
		/* position: relative; */
	}
	.radius_rectangle{
		border-radius: 0.48rem 0.5rem 0 0; 
		background: #F7F8FA;
		height: 0.4rem;
		width: 100%;
		position: relative;
		bottom: -1px;
		z-index: 1;
	}
	.fixed_box_top ul li{
		height: 1.8rem;
		line-height: 1.8rem;
		border:0 none;
	}
	.fixed_box_top ul{
			height: 1.8rem;
			line-height: 1.8rem;
			border:0 none;
	}
	.fixed_box_top{
		height: 2.2rem;
		color: #FFFFFF;
		font-size: 0.64rem;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		z-index: 101;
		/* overflow: hidden; */
	}
	.fixed_box_top.current_fixed{
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		background:#FF2612 ;
		z-index: 97;
		/* height: 0.36rem; */
	}
	.fixed_box_top.current_fixed li{
		background:#FF2612 ;
	}
	/* .list_box.index_z{
		z-index: 98;
		position: relative;
	} */
	.fixed_box_top li{
		flex-grow: 1;
		text-align: center;
		position: relative;
		height: 0.64rem;
		line-height: 0.64rem;
	}
	.fixed_box_top li i{
		width: 0.8rem;
		height: 0.12rem;
		background: #FFFFFF;
		border-radius: 0.08rem;
		position: absolute;
		left: 50%;
		bottom:0.28rem;
		transform: translateX(-50%);
		display: none;
	}
	.fixed_box_top li.active{
		font-weight: bold;
		font-size: 0.64rem;
	}
	.fixed_box_top li.active i{
		display: block;
	}
	.top_banner_box{
		height: 8.5rem;
		position: relative;
		z-index: 99;
	}
	.top_banner_img{
		position: absolute;
		left: 0;
		right: 0;
		height: 8.4rem;
		width: 100%;
		overflow: hidden;
		background: #FF1300;
	}
	.null_data_style{
		text-align: center;
		color: #969799;
		font-size: 0.56rem;
	}
</style>